import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-return-all-date',
  templateUrl: './return-all-date.component.html',
  styleUrls: ['./return-all-date.component.css']
})
export class ReturnAllDateComponent implements OnInit {

  data_model = {
    'invoice_no': '', 'invoice_date': new Date(), 'return_date': undefined
  };

  Return_Date_Msg;

  constructor(private dialogRef: MatDialogRef<ReturnAllDateComponent>, 
    @Inject(MAT_DIALOG_DATA) public dialog_data: any, public applicationConstants: ApplicationConstants, 
    public translate: TranslateService) { 
      this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Return_Date_Msg').subscribe((res: string) => {
      this.Return_Date_Msg = res;
    });
  }

  ngOnInit() {

    if (this.dialog_data != null) {
      this.data_model['invoice_no'] = this.dialog_data[0]['invoice_no'];
      this.data_model['invoice_date'] = new Date(this.dialog_data[0]['invoice_date']);
    //   this.data_model['return_date'] = new Date(this.dialog_data[0]['invoice_date']);
    //   this.data_model['return_date'].setTime(this.data_model['return_date'].getTime() + (1 * 60 * 1000));
    //   this.data_model['invoice_date'] = new Date(this.data_model['return_date']);
      console.log(this.data_model['invoice_date']);
    }
  }

  returnInvoice() {
    let return_date;
    
    if (this.data_model['return_date'] == undefined) {
      alert(this.Return_Date_Msg);
      return;
    }

    if (new Date().getMinutes() != this.data_model['invoice_date'].getMinutes() || 
      this.data_model['return_date'].getDate() != this.data_model['invoice_date'].getDate() ||  
      this.data_model['return_date'].getMonth() != this.data_model['invoice_date'].getMonth() || 
      this.data_model['return_date'].getFullYear() != this.data_model['invoice_date'].getFullYear()) {

      return_date = (this.data_model['return_date'].getFullYear() + "-" + (this.data_model['return_date'].getMonth() + 1) + "-" + 
        this.data_model['return_date'].getDate() + ' ' + new Date().getHours() + ':' + new Date().getMinutes() +
        ':' + new Date().getSeconds());
      
      this.data_model['return_date'] = new Date(return_date);
    }
    else {
      alert(this.Return_Date_Msg);
      return;
    }
      // this.data_model['return_date'] = new Date(this.data_model['invoice_date']);
    
    console.log(this.data_model['return_date']);
    
    this.dialog_data = { 'op_type': 'success', 'return_date': this.data_model['return_date'] };
    this.dialogRef.close(this.dialog_data);
  }

  cancel() {
    this.dialog_data = { 'op_type': 'error' };
    this.dialogRef.close(this.dialog_data);
  }

}
